import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ForgotPasswordPage.css';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email) {
      setError('Vennligst oppgi din e-postadresse');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Vennligst oppgi en gyldig e-postadresse');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSuccess(true);
    } catch (err: any) {
      // Don't reveal if email exists or not for security
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <h1>Glemt passord?</h1>
          <p className="subtitle">
            Skriv inn e-postadressen din, så sender vi deg instruksjoner for å tilbakestille passordet.
          </p>

          {success ? (
            <div className="success-container">
              <div className="success-message">
                <h2>✅ E-post sendt!</h2>
                <p>
                  Hvis det finnes en konto med e-postadressen <strong>{email}</strong>, har du mottatt en e-post med instruksjoner for å tilbakestille passordet.
                </p>
                <p className="hint">
                  Sjekk også spam-mappen din hvis du ikke finner e-posten.
                </p>
              </div>
              <Link to="/logg-inn" className="btn btn-primary btn-full">
                Tilbake til innlogging
              </Link>
            </div>
          ) : (
            <>
              {error && <div className="error-message">{error}</div>}

              <form onSubmit={handleSubmit} className="forgot-password-form">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    E-postadresse
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="din@epost.no"
                    disabled={loading}
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-full"
                  disabled={loading}
                >
                  {loading && (
                    <span className="spinner" role="status" aria-label="Laster">
                      <svg className="spinner-icon" viewBox="0 0 50 50">
                        <circle
                          className="spinner-path"
                          cx="25"
                          cy="25"
                          r="20"
                          fill="none"
                          strokeWidth="4"
                        ></circle>
                      </svg>
                    </span>
                  )}
                  {loading ? 'Sender e-post...' : 'Send tilbakestillings-lenke'}
                </button>
              </form>

              <div className="forgot-password-footer">
                <p>
                  Husker du passordet?{' '}
                  <Link to="/logg-inn" className="link">
                    Logg inn her
                  </Link>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
